module.exports = __webpack_public_path__ + "media/images/nita-square-06fe66125a96bd72b1ec82a5fe989676.png";